import type { FaireThemeEntity } from "../../entity_types/theme";

export const coastal_california_gifting: FaireThemeEntity = {
  token: "coastal-california-gifting",
  type: "theme",
  retailerToken: "r_rk3595bqqg",
  name: "Coastal California Gifting",
  description: "California-inspired gifts for your coastal boutique",
  bgColor: "#F5E6C8",
  tileBgColor: "#855f2c",
  productTokens: [
    "p_a9rt24w0gn",
    "p_kv3vdqny5c",
    "p_dm7ejpzu8e",
    "p_avhrk6rvjp",
    "p_tqhjaddw2v",
    "p_3hcsxm54zn",
    "p_4ufvtqbebc",
    "p_pmqce2g3pt",
    "p_caepkc3ekv",
    "p_t57k5ytx66",
    "p_ks2779fybv",
    "p_7yuxztca83",
    "p_qp3hymq826",
    "p_efh6wgp3rm",
    "p_tvpzhyjtmm",
    "p_81ozsbcrsg",
    "p_r9w24xycy9",
    "p_dyb22jzkrz",
    "p_9ouu0s1k",
    "p_8drwd5g4pa",
    "p_6zym5xszc3",
    "p_r9pzzxsm3u",
    "p_8hd8kfy8xx",
    "p_u8x67gferp",
    "p_s86r2pkv42",
    "p_az4n38krcc",
    "p_5b693e5wtn",
    "p_y67566sr9n",
    "p_z67nypuv9s",
    "p_a89h9uud4t",
    "p_w3s5zfaud2",
    "p_9xxckzw2r6",
    "p_fxyq3y2qn3",
    "p_3ytdnhptzb",
    "p_rwpfpux8dx",
    "p_dhxhxst4nd",
    "p_aph97ufnp7",
    "p_b4atn7bfq6",
    "p_7srdr3shgj",
    "p_5qawrfjq5a",
    "p_3bqc66q5f2",
    "p_ngvjjmwxks",
    "p_8jrrbl9v",
    "p_7ezc1gekjy",
  ],
  exactProducts: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:50:10Z",
    importedBy: "retailer-themes-entity-migration",
  },
};
